export default __webpack_public_path__ + "components/leaflet/static/placeholder-0c56d52bce1a5ecdc2391ee0ac598779.jpg";